module.exports = __webpack_public_path__ + "static/media/diariodesevilla.57116b12.png";